export default __webpack_public_path__ + "static/media/dining-hall-shortages.482f3331.png";